//Test to mix container and component (presentation and logic)

import React from 'react';
import { connect } from 'react-redux'

import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);


const mapStateToProps = (state) => {
	return state;
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

class Legend extends React.Component {


	componentDidMount() {


	}


	render() {
		console.log(this.props);


		var dist = this.props.poster.labels.calculatedDistance;
		if (this.props.poster.unit === 'mi') {
			dist = (this.props.poster.labels.calculatedDistance * 0.621371).toFixed(1)
		}
		var distance = dist + this.props.poster.unit;
		if (this.props.poster.labels.distance !== '') {
			distance = this.props.poster.labels.distance
		}

		var avg_speed = '-';
		var max_speed = '-';
		var avg_cadence = '-';
		var avg_hr = '-';
		var max_hr = '-';
		var elev_high = '-';
		var elev_low = '-';
		var elev_gain = '-';

		var activity = this.props.poster.data;
		if (activity) {
			if (activity.start_latlng) {
				avg_speed = (activity.average_speed * 3600 / 1000).toFixed(1)
				max_speed = (activity.max_speed * 3600 / 1000).toFixed(1)

				elev_high = activity.elev_high.toFixed(1) + 'm'
				elev_low = activity.elev_low.toFixed(1) + 'm'
				elev_gain = activity.total_elevation_gain.toFixed(1) + 'm'

				if (this.props.poster.unit === 'mi') {
					avg_speed = (activity.average_speed * 3600 / 1609.34).toFixed(1)
					max_speed = (activity.max_speed * 3600 / 1609.34).toFixed(1)

					elev_high = (activity.elev_high * 3.28084).toFixed(1) + 'ft'
					elev_low = (activity.elev_low * 3.28084).toFixed(1) + 'ft'
					elev_gain = (activity.total_elevation_gain * 3.28084).toFixed(1) + 'ft'
				}
			}

			if (activity.average_cadence) {
				avg_cadence = Math.round(activity.average_cadence * 2)
			}

			if (activity.has_heartrate) {
				avg_hr = Math.round(activity.average_heartrate)
				max_hr = activity.max_heartrate
			}



		}
		return (


			<g>
				<rect id='textRect' x='0' y={this.props.poster.layout.height - this.props.poster.legend.height} width={this.props.poster.layout.width} height={this.props.poster.legend.height} />
				<rect x='0' y={this.props.poster.layout.height - this.props.poster.legend.height - this.props.poster.legend.spacer} width={this.props.poster.layout.width} height={this.props.poster.legend.spacer} fill='black' />
				<text id='subtitle' x={this.props.poster.layout.width / 2} y={this.props.poster.layout.height - 60} textAnchor='middle'>
					{this.props.poster.labels.title}
				</text>
				<text className='text' id='athlete' x="12" y={this.props.poster.layout.height - 45} textAnchor='left'>
					{this.props.poster.labels.athlete}
				</text>
				<text className='text' x="12" y={this.props.poster.layout.height - 32}>
					DATE : {this.props.poster.labels.subtitle}
				</text>
				<text className='text' x="12" y={this.props.poster.layout.height - 19}>
					DISTANCE : {distance}
				</text>
				<text className='text' x="12" y={this.props.poster.layout.height - 6} textAnchor='left'>
					TIME : {this.props.poster.labels.time}
				</text>

				<text className='text' x={this.props.poster.layout.width - 310} y={this.props.poster.layout.height - 32} textAnchor='left'>
					SPEED: {avg_speed + this.props.poster.unit}/h (Max : {max_speed + this.props.poster.unit}/h)
				</text>
				<text className='text' x={this.props.poster.layout.width - 310} y={this.props.poster.layout.height - 19} textAnchor='left'>
					HEARTRATE: {avg_hr}bpm (Max: {max_hr}bpm)
				</text>
				<text className='text' x={this.props.poster.layout.width - 310} y={this.props.poster.layout.height - 6} textAnchor='left'>
					CADENCE: {avg_cadence}spm
				</text>

				<text className='text' x={this.props.poster.layout.width - 90} y={this.props.poster.layout.height - 45} textAnchor='left'>
					ELEVATION
				</text>
				<text className='text' x={this.props.poster.layout.width - 90} y={this.props.poster.layout.height - 32} textAnchor='left'>
					Low: {elev_low}
				</text>
				<text className='text' x={this.props.poster.layout.width - 90} y={this.props.poster.layout.height - 19} textAnchor='left'>
					High: {elev_high}
				</text>
				<text className='text' x={this.props.poster.layout.width - 90} y={this.props.poster.layout.height - 6} textAnchor='left'>
					Gain: {elev_gain}
				</text>
			</g>

		)
	}
}

Legend = connect(
	mapStateToProps,
	mapDispatchToProps
)(Legend)

export default Legend;


// WEBPACK FOOTER //
// ./src/components/Legend.js